'use strict';

export default function($stateProvider) {
  'ngInject';

  $stateProvider
    .state('tvs_benchmark', {
      url: '/tvs_benchmark',
      template: '<tvsbenchmarktab></tvsbenchmarktab>',
      authenticate: 'admin'
    });
}
